import React, { useState, useRef, useEffect } from 'react';
import { Box, Typography, Paper, Stack, LinearProgress } from '@mui/material';
import { CloudUpload as CloudUploadIcon } from '@mui/icons-material';
import { useAuth } from '../components/AuthContext';
import { API_BASE_URL } from '../components/api.js';

const LercsvCupons = () => {
    const [file, setFile] = useState(null);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const fileInputRef = useRef(null);
    const [elapsedTime, setElapsedTime] = useState(0);
    const timerRef = useRef(null); 

    const { authenticatedFetch, logout } = useAuth();

    const startProgressTimer = () => {
        clearInterval(timerRef.current);
        setElapsedTime(0);
        timerRef.current = setInterval(() => {
            setElapsedTime(oldTime => oldTime + 1);
        }, 1000); 
    };

    const stopProgressTimer = () => {
        clearInterval(timerRef.current);
    };    

    const processFile = async (selectedFile) => {
        setIsLoading(true);
        setError('');
        startProgressTimer(); 

        const formData = new FormData();
        formData.append('file', selectedFile);

        try {
            console.log('1')
            const response = await authenticatedFetch('' + API_BASE_URL + '/api/processar-descontos/', {
                method: 'POST',
                body: formData,
            });
            console.log('2')
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Erro ao processar o arquivo.');
            }

            setError('Arquivo processado com sucesso. O relatório foi gerado no sistema.');
            setFile(null);
        } catch (err) {
        if (err.message.includes('Token')) {
                        logout();
                    } else {
                        setError('Erro: ' + err.message);
                        alert('Erro: ' + err.message);
                    }
            setFile(null);
        } finally {
            setIsLoading(false);
            stopProgressTimer();
        }
    };

    const handleFileChange = (event) => {
        const uploadedFile = event.target.files[0];
        if (uploadedFile) {
            setFile(uploadedFile);
            processFile(uploadedFile);
        }
    };

    const handleDrop = (event) => {
        event.preventDefault();
        if (isLoading) return;

        const uploadedFile = event.dataTransfer.files[0];
        if (uploadedFile) {
            setFile(uploadedFile);
            processFile(uploadedFile);
        }
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    };

    useEffect(() => {
        return () => {
            clearInterval(timerRef.current);
        };
    }, []);    

    // Função para abrir o seletor de arquivos quando clicar no Paper
    const handlePaperClick = () => {
        if (!isLoading && fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    return (
        <Box sx={{ p: 3, maxWidth: '800px', mx: 'auto' }}>
            <Typography variant="body1" sx={{ mb: 2 }}>
                {/* 🎯 TEXTO ATUALIZADO AQUI */}
                Caminho no swfast: Relatório dinâmico - Vendas - Preferência: Op, q, valor, total, cupom - Filtro: Por data
                Em Opções - Layout selecionar Forma plana
                {/* --------------------------- */}
            </Typography>

            <Typography variant="body1" sx={{ mb: 1 }}>
                Selecione o arquivo e arraste:
            </Typography>

            <Paper
                variant="outlined"
                sx={{
                    p: 4,
                    textAlign: 'center',
                    cursor: isLoading ? 'default' : 'pointer',
                    border: '2px dashed',
                    borderColor: error ? 'error.main' : (file ? 'success.main' : 'text.secondary'),
                    '&:hover': {
                        borderColor: isLoading ? 'text.secondary' : 'primary.main',
                        backgroundColor: isLoading ? 'background.paper' : 'action.hover',
                    },
                    backgroundColor: 'background.paper',
                    position: 'relative',
                    transition: 'all 0.2s ease-in-out',
                }}
                onClick={handlePaperClick}
                onDrop={handleDrop}
                onDragOver={handleDragOver}
            >
                <input
                    type="file"
                    hidden
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    accept=".xlsx, .xls, .csv"
                />
                <Stack
                    direction="column"
                    alignItems="center"
                    spacing={2}
                >
                    <CloudUploadIcon 
                        sx={{ 
                            fontSize: 40, 
                            color: 'text.secondary',
                            transition: 'color 0.2s ease-in-out',
                        }} 
                    />
                    <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                        {file ? file.name : 'Clique aqui ou arraste e solte o arquivo'}
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                        Limite de 200MB por arquivo .XLSX, .XLS, .CSV
                    </Typography>
                </Stack>
                {isLoading && (
                    <Box sx={{ width: '100%', mt: 2 }}>
                        <LinearProgress />
                        <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
                            Processando arquivo... {elapsedTime} segundos
                        </Typography>
                    </Box>
                )}
            </Paper>

            {error && (
                <Typography 
                    variant="body2" 
                    color={error.includes('sucesso') ? 'success.main' : 'error.main'} 
                    sx={{ mt: 2, textAlign: 'center' }}
                >
                    {error}
                </Typography>
            )}
        </Box>
    );
};

export default LercsvCupons;